import React from "react";
import './Home.css'
import "../App.css";
import './Services.css'
const servicesData = [
  {
    title: "General Medicine",
    desc: "Preventive & chronic disease care for all ages.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "General & Laparoscopic Surgery",
    desc: "Minimally invasive procedures with faster recovery.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "24×7 Accident, Emergency & Trauma Care",
    desc: "Round-the-clock urgent care with advanced ICU.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Orthopedics & Joint Replacement",
    desc: "Expert bone, joint & spine treatments.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Physiotherapy & Rehabilitation",
    desc: "Post-surgery recovery & chronic condition support.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Urology & Nephrology",
    desc: "Kidney & urinary tract treatments with dialysis services.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Oncology",
    desc: "Comprehensive cancer care & chemotherapy.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Neurology & Neurosurgery",
    desc: "Brain, spine & nerve disorder treatments.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Gynecology & Obstetrics",
    desc: "Prenatal care, high-risk deliveries & advanced surgeries.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Pediatrics & Neonatal Care",
    desc: "Specialized care for infants & children.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Psychiatry & Mental Health",
    desc: "Counseling & treatment for mental health conditions.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Dermatology & Skin Care",
    desc: "Skin treatments, cosmetic & laser therapies.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Burns, Plastic & Reconstructive Surgery",
    desc: "Advanced surgical care & aesthetic restoration.",
    img: "assets/img/all-images/service/service-img19.png",
  },
  {
    title: "Corporate Health Check-ups",
    desc: "Tailored preventive programs & wellness camps.",
    img: "assets/img/all-images/service/service-img17.png",
  },
  {
    title: "Pathology & Diagnostic Services",
    desc: "Accurate & timely lab investigations.",
    img: "assets/img/all-images/service/service-img18.png",
  },
  {
    title: "Advanced Radiology Imaging",
    desc: "X-ray, MRI, CT Scan & Ultrasound services.",
    img: "assets/img/all-images/service/service-img19.png",
  },
];

function Service() {
  return (
    <>
<div className="service4-section-area sp1">
      <div className="container-fluid no-gutter">
        <div className="container">

          {/* Heading */}
  <div className="row">
    <div className="col-lg-6 m-auto">
      <div className="heading4 text-center">
        <h5 className="vl-section-subtitle">
          JEEVANDAAN Hospital<span> | </span>Department{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
          >
            <path
              d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992"
              stroke="#b2442c"
              strokeWidth="1.5"
            />
          </svg>
        </h5>
      </div>
    </div>
  </div>

  {/* h2 full width */}
<div className="row">
  <div className="col-10 mx-auto">
    <div className="heading4 text-center space-margin60">
      <h2 className="vl-section-title text-anime-style-3">
        Our specialized departments work together seamlessly
      </h2>
    </div>
  </div>
</div>

        </div>

        {/* Services */}
        <div className="row">
          <div className="col-lg-12">
            <div className="service-carousel-wrapper">
              <div className="service-carousel-track">
                {servicesData.map((service, index) => (
                  <div className="service-card" key={index}>
                    <h4>{service.title}</h4>
                    <p>{service.desc}</p>
                    <a href="service-single.html" className="medicax-service-link">
  Learn More
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301L9.52852 7.52827C9.78887 7.78861 9.78887 8.21072 9.52852 8.47107L7.33325 10.6663"
      fill="currentColor"
    />
  </svg>
</a>

                    <img src={service.img} alt={service.title} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
{ /*===== HERO AREA ENDS =======*/ }
    </>
    
  );
}

export default Service;
